<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <div class="card main-card">
            <div class="card-body">
              <!-- Search -->
              <div class="search-section">
                <div class="row">
                  <div class="col-md-5 col-sm-4">
                    <div class="form-wrap icon-form">
                      <span class="form-icon"><i class="ti ti-search"></i></span>
                      <input type="text" class="form-control" placeholder="Search by Number or Title"
                        v-model="searchQuery" @input="searchCases(1)" />
                    </div>
                  </div>
                  <div class="col-md-7 col-sm-8">
                    <div class="export-list text-sm-end">
                      <ul class="d-flex gap-2 justify-content-end">
                        <!-- Filter Dropdown -->
                        <li>
                          <div class="form-sorts dropdown">
                            <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                              <i class="ti ti-filter-share"></i> Filter
                            </a>
                            <div class="filter-dropdown-menu dropdown-menu dropdown-menu-xl-end">
                              <div class="filter-set-view">
                                <div class="filter-set-head">
                                  <h4><i class="ti ti-filter-share"></i> Filter</h4>
                                </div>

                                <!-- Date Range Picker -->
                                <div class="filter-content-list">
                                  <label class="mb-2">Start Date - End Date</label>
                                  <date-time-picker v-model="filters.date" range multi-calendars
                                    :enable-time-picker="false" format="yyyy-MM-dd" />
                                </div>

                                <!-- Status Filter -->
                                <div class="filter-content-list">
                                  <label class="mb-2">Status</label>
                                  <div class="form-wrap icon-form">
                                    <span class="form-icon"><i class="ti ti-search"></i></span>
                                    <vue-select :options="statusData" v-model="filters.status"
                                      :settings="{ multiple: true, placeholder: 'Select...' }" placeholder="Select..."
                                      @select="myChangeEvent($event, 'status')" autocomplete="off" autocorrect="off"
                                      autocapitalize="off" spellcheck="false" />
                                  </div>
                                </div>

                                <!-- Priority Filter -->
                                <div class="filter-content-list">
                                  <label class="mb-2">Priority</label>
                                  <div class="form-wrap icon-form">
                                    <span class="form-icon"><i class="ti ti-search"></i></span>
                                    <vue-select :options="priorityData" v-model="filters.priority"
                                      :settings="{ multiple: true, placeholder: 'Select...' }" placeholder="Select..."
                                      @select="myChangeEvent($event, 'priority')" autocomplete="off" autocorrect="off"
                                      autocapitalize="off" spellcheck="false" />
                                  </div>
                                </div>

                                <!-- Type Filter -->
                                <div class="filter-content-list">
                                  <label class="mb-2">Type</label>
                                  <div class="form-wrap icon-form">
                                    <span class="form-icon"><i class="ti ti-search"></i></span>
                                    <vue-select :options="typeData" v-model="filters.type"
                                      :settings="{ multiple: true, placeholder: 'Select...' }" placeholder="Select..."
                                      @select="myChangeEvent($event, 'type')" autocomplete="off" autocorrect="off"
                                      autocapitalize="off" spellcheck="false" />
                                  </div>
                                </div>
                              </div>

                              <!-- Buttons -->
                              <div class="filter-reset-btns">
                                <div class="row">
                                  <div class="col-6">
                                    <a href="javascript:void(0);" class="btn btn-light" @click="resetFilters">Reset</a>
                                  </div>
                                  <div class="col-6">
                                    <a href="javascript:void(0);" class="btn btn-primary"
                                      @click="applyFilters">Filter</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <!-- Add Button -->
                        <li>
                          <router-link to="/crm/create-support-case" class="btn btn-primary">
                            <i class="ti ti-square-rounded-plus"></i> Add
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>
              <!-- /Search -->

              <!-- Activity List -->
              <div class="table-responsive custom-table">
                <support-case-table ref="caseTable" :searchQuery="searchQuery"
                  :filters="appliedFilters"></support-case-table>
              </div>
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="datatable-length"></div>
                </div>
                <div class="col-md-6">
                  <div class="datatable-paginate"></div>
                </div>
              </div>
              <!-- /Activity List -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeUnmount, computed, nextTick } from 'vue';
import apiClient from '@/axios';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'CasesComponent',
  components: {},
  data() {
    return {
      title: "Support Tickets",
      searchQuery: '',
    };
  },
  setup(props, { expose }) {
    const store = useStore();
    const appliedFilters = ref();

    const statusData = ref([])
    const priorityData = ref([])
    const typeData = ref([])


    const caseTable = ref()

    const filters = ref({
      date: null,
      type: [],
      priority: [],
      status: [],
      user: []
    })

    function resetFilters() {
      filters.value = {
        date: null,
        type: [],
        priority: [],
        status: [],
        user: []
      }
      applyFilters()
    }

    const applyFilters = () => {
      appliedFilters.value = { ...filters.value };
      nextTick(() => {
        searchCases();
      });
    };

    const fetchUsers = async () => {
      try {
        const response = await store.dispatch('suppportCases/fetchcasesOptions');
        statusData.value = [
          { id: 'null', text: 'Select....', original: null },
          ...response.status.map(item => ({
            id: item.value,
            text: item.text
          }))
        ];

        priorityData.value = [
          { id: 'null', text: 'Select....', original: null },
          ...response.priority.map(item => ({
            id: item.value,
            text: item.text
          }))
        ];

        typeData.value = [
          { id: 'null', text: 'Select....', original: null },
          ...response.type.map(item => ({
            id: item.value,
            text: item.text
          }))
        ];

      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    const searchCases = async (page=1) => {
      if (caseTable.value) {
        caseTable.value.fetchCases(page)
      }
    };


    const myChangeEvent = (event, field) => {
      if (event.id === 'null') {
        if (field === 'statu') {
          filters.value.status = '';
        } else if (field === 'priority') {
          filters.value.priority = '';
        } else {
          filters.value.type = '';
        }
      }
    }

    onMounted(async () => {
      fetchUsers()
    });

    return {
      appliedFilters,
      searchCases,
      caseTable,
      filters,
      resetFilters,
      applyFilters,
      myChangeEvent,
      statusData,
      priorityData,
      typeData,
      fetchUsers

    };
  }
});
</script>